import { ShippingMethod } from "inbounds/ShippingMethod";
import { getIsSpdDeliverr } from "./getIsSpdDeliverr";
import { getIsFreightDeliverr } from "./getIsFreightDeliverr";
import { getIsMetro } from "./getIsMetro";

export const getIsDeliverr = (shippingMethod?: ShippingMethod): boolean =>
  getIsSpdDeliverr(shippingMethod) || getIsFreightDeliverr(shippingMethod) || getIsMetro(shippingMethod);
